import React from "react";

import moment from "moment";

import Alert from "@busbud/design-system-components/dist/Alert";
import MoonSM from "@busbud/design-system-components/dist/Icons/Moon/SM";

import { useAppContext } from "@app/helpers/hooks";
import type { TranslatorService } from "@app/services/translator";

interface Props {
  /** Departure date time in ISO format, e.g 2022-02-01T01:52:00 */
  iso_departure_datetime?: string | null;
  className?: string;
}

const AmbiguousDepartureTimeAlert: React.FC<Props> = ({
  className,
  iso_departure_datetime
}) => {
  const { translator, features } = useAppContext();
  if (
    features.RESULTS_SHOULD_HIDE_ALERT_DEPARTURE_DURING_THE_NIGHT ||
    !iso_departure_datetime
  ) {
    return null;
  }

  const _departure_datetime = moment(iso_departure_datetime);

  // do not display the message for departures after 5am
  if (_departure_datetime.hour() > 5) {
    return null;
  }

  return (
    <Alert className={className} severity="notice" icon={<MoonSM />} size="sm">
      {getAmbiguousDepartureTimeMessage(
        _departure_datetime.weekday(),
        translator
      )}
    </Alert>
  );
};

const getAmbiguousDepartureTimeMessage = (
  day_of_week: number,
  translator: TranslatorService
) => {
  const messages = [
    translator.t("!results.departure.ambiguous-travel-day-saturday-to-sunday"),
    translator.t("!results.departure.ambiguous-travel-day-sunday-to-monday"),
    translator.t("!results.departure.ambiguous-travel-day-monday-to-tuesday"),
    translator.t(
      "!results.departure.ambiguous-travel-day-tuesday-to-wednesday"
    ),
    translator.t(
      "!results.departure.ambiguous-travel-day-wednesday-to-thursday"
    ),
    translator.t("!results.departure.ambiguous-travel-day-thursday-to-friday"),
    translator.t("!results.departure.ambiguous-travel-day-friday-to-saturday")
  ];
  return messages[day_of_week] || "";
};

export default AmbiguousDepartureTimeAlert;
